import React from "react";
import { TelegramIcon, TiktokIcon, WhatsappIcon } from "@/svgs";
import "./ContactUs.css";

const ContactUs: React.FC = () => {
  return (
    <section className="contact-link-itens">
      <div className="contact-link-item">
        <h2>Fale conosco</h2>

        <p>
          Nossa equipe está disponível para ajudar, esclarecer dúvidas e ouvir
          sugestões. Priorizamos uma experiência segura, discreta e de alta
          qualidade para todos os membros.
        </p>

        <div className="contact-links">
          <a
            href={process.env.REACT_APP_TELEGRAM}
            target="_blank"
            rel="noopener noreferrer"
          >
            <TelegramIcon />
            Telegram
          </a>

          <a
            href={process.env.REACT_APP_WHATSAPP}
            target="_blank"
            rel="noopener noreferrer"
          >
            <WhatsappIcon />
            WhatsApp
          </a>

          <a
            href={process.env.REACT_APP_TIKTOK}
            target="_blank"
            rel="noopener noreferrer"
          >
            <TiktokIcon />
            TikTok
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
